import type { IProductRepository } from '@/core/domain/repositories/IProductRepository';
import type { CollectionPage } from '@/core/domain/entities/Product';

export class GetCollectionUseCase {
  constructor(private readonly repository: Pick<IProductRepository, 'getCollection'>) {}

  execute(slug: string, page: number): Promise<CollectionPage> {
    return this.repository.getCollection(slug, page, 20);
  }
}
